import type { ElementType } from 'react';
import { Link, styled } from '@mui/material';

/** Text shapes read as part of the surrounding copy; the underline appears on hover and keyboard focus. */
export const GuideTextLink = styled(Link)<{ component?: ElementType }>({
  '&:focus-visible': { textDecoration: 'underline' },
});
